import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { createClaimCampaign } from '~/services/ClaimCampaignService';

import type { CreateClaimCampaignBody } from '~/types/claimCampaignTypes';

import { claimCampaignQueryKeys } from './claimCampaignQueryKeys';

/**
 * Creates a new claim campaign and invalidates the campaign list cache.
 */
export function useCreateClaimCampaign() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (body: CreateClaimCampaignBody) => {
      return await createClaimCampaign(body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: claimCampaignQueryKeys.all });
      enqueueSnackbar('Claim campaign created successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error creating claim campaign: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
